import { Controller } from "@hotwired/stimulus"
import { toast } from "../services/toast"

export default class extends Controller {
  static targets = ["canvas", "form", "canvasWrapper"]
  static values = { templateId: Number }

  connect() {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')
    if (!csrfToken) {
      console.warn('CSRF token not found')
      return
    }
    
    this.updatePreview()
  }

  updatePreview() {
    if (!this.hasFormTarget || !this.hasCanvasTarget) {
      return
    }

    const formData = new FormData(this.formTarget)
    const data = {}
    
    for (let [key, value] of formData.entries()) {
      if (key.startsWith('data[')) {
        const fieldName = key.match(/data\[(.*?)\]/)[1]
        data[fieldName] = value.trim()
      }
    }

    this.canvasTarget.querySelectorAll('.canvas-element[data-element-type="text"]').forEach(element => {
      const textType = element.dataset.textType
      const span = element.querySelector('.element-preview-text')
      
      if (span) {
        if (data[textType]) {
          span.textContent = data[textType]
          span.style.color = '#000'
          span.style.fontStyle = 'normal'
        } else {
          const placeholders = {
            brand: "Marca", model: "Modelo", color: "Color", cut: "Corte",
            category: "Categoría", general_category: "Categoría General",
            supplier: "Proveedor", cost: "Costo", price: "Precio",
            size: "Talla", custom: "Texto personalizado", qr_code: "Código QR"
          }
          span.textContent = placeholders[textType] || textType.charAt(0).toUpperCase() + textType.slice(1)
          span.style.color = '#999'
          span.style.fontStyle = 'italic'
        }
      }
    })
  }

  async generateLabel(event) {
    event.preventDefault()
    
    const formData = new FormData(this.formTarget)
    const data = {}
    
    for (let [key, value] of formData.entries()) {
      if (key.startsWith('data[')) {
        const fieldName = key.match(/data\[(.*?)\]/)[1]
        data[fieldName] = value
      }
    }

    const csrfToken = document.querySelector('meta[name="csrf-token"]')
    if (!csrfToken) {
      toast.error('Error: Token CSRF no encontrado')
      return
    }

    try {
      event.target.disabled = true
      const originalText = event.target.innerHTML
      event.target.textContent = 'Generando...'

      const response = await fetch(`/admin/herramientas-qr/${this.templateIdValue}/generate_label`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-CSRF-Token': csrfToken.getAttribute('content')
        },
        body: JSON.stringify({ data: data })
      })

      if (response.ok) {
        const result = await response.json()
        if (result.success && result.pdf_data) {
          const binaryString = atob(result.pdf_data)
          const bytes = new Uint8Array(binaryString.length)
          for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i)
          }
          const blob = new Blob([bytes], { type: 'application/pdf' })
          
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.download = result.filename || `etiqueta_${Date.now()}.pdf`
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
        }
      } else {
        throw new Error('Error al generar la etiqueta')
      }
      
      event.target.disabled = false
      event.target.innerHTML = originalText
    } catch (error) {
      console.error('Error:', error)
      toast.error('Error al generar la etiqueta: ' + error.message)
      event.target.disabled = false
    }
  }

  async printLabel(event) {
    event.preventDefault()
    
    const formData = new FormData(this.formTarget)
    const data = {}
    
    for (let [key, value] of formData.entries()) {
      if (key.startsWith('data[')) {
        const fieldName = key.match(/data\[(.*?)\]/)[1]
        data[fieldName] = value
      }
    }

    const csrfToken = document.querySelector('meta[name="csrf-token"]')
    if (!csrfToken) {
      toast.error('Error: Token CSRF no encontrado')
      return
    }

    try {
      event.target.disabled = true
      const originalText = event.target.textContent
      event.target.textContent = 'Imprimiendo...'

      const response = await fetch(`/admin/herramientas-qr/${this.templateIdValue}/print_label`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-CSRF-Token': csrfToken.getAttribute('content')
        },
        body: JSON.stringify({ data: data })
      })

      if (response.ok) {
        const result = await response.json()
        if (result.success) {
          toast.success(result.message || 'Etiqueta enviada a impresora correctamente')
        } else {
          throw new Error(result.message || 'Error al imprimir la etiqueta')
        }
      } else {
        throw new Error('Error al imprimir la etiqueta')
      }
      
      event.target.disabled = false
      event.target.textContent = originalText
    } catch (error) {
      console.error('Error:', error)
      toast.error('Error al imprimir la etiqueta: ' + error.message)
      event.target.disabled = false
    }
  }
}
